"use strict";
/**
 * API helper functions for AcademicProgram endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.academicProgramApi = void 0;
const apiClient_1 = require("./apiClient");
const validation_1 = require("./validation");
const apiMappers_1 = require("./apiMappers");
exports.academicProgramApi = {
    /**
     * Fetch approved academic programs for a tenant
     * Note: Fetches all programs by tenant, then filters to approved ones client-side
     * This matches the Angular implementation in academic-program.service.ts
     */
    getApprovedPrograms: (tenantId) => {
        (0, validation_1.validateId)(tenantId, 'Tenant ID');
        return apiClient_1.apiClient
            .get(`/academicProgram/tenant/${tenantId}`)
            .then(data => data
            .map(apiMappers_1.mapAcademicProgram)
            .filter(program => program.active !== false) // Filter to approved/active programs
            .sort((a, b) => a.name.localeCompare(b.name)) // Sort alphabetically by name
        );
    },
    /**
     * Fetch a single academic program by ID
     */
    getProgramById: (id) => {
        (0, validation_1.validateId)(id, 'Academic Program ID');
        return apiClient_1.apiClient.get(`/academicProgram/${id}`).then(apiMappers_1.mapAcademicProgram);
    },
    /**
     * Fetch academic programs by organization
     */
    getProgramsByOrganization: (orgId) => {
        (0, validation_1.validateId)(orgId, 'Organization ID');
        return apiClient_1.apiClient.get(`/academicProgram/organization/${orgId}`).then(data => data.map(apiMappers_1.mapAcademicProgram));
    },
};
